import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { objectTypes, withTrackEvent, actionNames } from "@newsela/snitch";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useStudentPreviewContext from "@/view/utils/useStudentPreviewContext";
import { footnoteCss, linkCss } from "./StudentAssignmentFootnote.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevelId: PropTypes.string,
  hasMultipleAssignments: PropTypes.bool,
};

const AssignmentStudentFootnote = ({
  assignmentId,
  currentContentLevelId,
  hasMultipleAssignments,
}) => {
  const { isStudentPreviewOn } = useStudentPreviewContext();

  if (!hasMultipleAssignments) return null;

  const getAssignmentLinkEventProps = {
    objectType: objectTypes.assignment,
    actionName: actionNames.navigate,
    streamProperties: {
      content_id: currentContentLevelId,
      content_type: "Article",
      description: "Navigate to student assignments",
      object_id: assignmentId,
    },
  };

  const renderAssignmentsLink = () => {
    const href = isStudentPreviewOn
      ? `${MONOLITH_ORIGIN}/binder/assignments/`
      : `${MONOLITH_ORIGIN}/assignments/`;

    return (
      <AnchorWithTrackEvent
        __cssFor={{ root: linkCss }}
        isInline
        href={href}
        {...getAssignmentLinkEventProps}
      >
        Assignments
      </AnchorWithTrackEvent>
    );
  };

  return (
    <p css={footnoteCss}>
      You have more than one assignment with this article. View them all in your
      {renderAssignmentsLink()}
    </p>
  );
};

AssignmentStudentFootnote.propTypes = propTypes;

export default AssignmentStudentFootnote;
